var map = {
	"./WAC.jpeg": 84,
	"./Wipro.png": 85,
	"./address_image.svg": 86,
	"./akatva.jpeg": 87,
	"./animated_ashutosh.png": 88,
	"./animated_logo.svg": 89,
	"./automotu.jpeg": 90,
	"./aws_logo.png": 91,
	"./blogs_image.svg": 92,
	"./cloud_infrastructure.svg": 93,
	"./codeInLogo.png": 94,
	"./contactMail.png": 95,
	"./coursera_logo.jpeg": 96,
	"./coursera_logo.png": 97,
	"./data_science.svg": 98,
	"./deeplearning_ai_logo.png": 99,
	"./delhivery_logo.png": 100,
	"./developerActivity.svg": 101,
	"./django.png": 102,
	"./django_logo.png": 103,
	"./dsc_logo.png": 104,
	"./education.svg": 105,
	"./ericsson-1-logo.png": 106,
	"./ericsson.png": 107,
	"./ericssonLogo.png": 108,
	"./ericsson_logo.png": 109,
	"./experience.svg": 110,
	"./expoodle-logo.png": 111,
	"./feelingProud.svg": 112,
	"./flask.png": 113,
	"./freecopy_logo.png": 114,
	"./fullstack.svg": 115,
	"./fusion.jpeg": 116,
	"./galgotia_logo_2.jpeg": 117,
	"./galgotias_logo.jpeg": 118,
	"./gcp_logo.png": 119,
	"./github_logo.png": 120,
	"./googleAssistant.jpg": 121,
	"./googleAssistant.svg": 122,
	"./google_logo.png": 123,
	"./ibm_logo.png": 124,
	"./ieee.jpeg": 125,
	"./iiitk_logo.png": 126,
	"./intel_logo.jpg": 127,
	"./iu_logo.png": 128,
	"./jaskaran_animated.png": 129,
	"./jsFramework.svg": 130,
	"./legato_logo.png": 131,
	"./linkedin_logo.jpeg": 132,
	"./manOnTable.svg": 133,
	"./microsoft.jpeg": 134,
	"./microsoft_logo.png": 135,
	"./mozilla_logo.png": 136,
	"./muffito_logo.png": 137,
	"./nextuLogo.jpg": 138,
	"./nptel_logo.png": 139,
	"./perspectico.png": 140,
	"./perspectico_logo.avif": 141,
	"./programmer.svg": 142,
	"./projects_image.svg": 143,
	"./pwa.png": 144,
	"./saayaHealthLogo.png": 145,
	"./slumswaraj.png": 146,
	"./spark.png": 147,
	"./stanford_logo.png": 148,
	"./superds.png": 149,
	"./superds2.jpeg": 150,
	"./talksCardBack.svg": 151,
	"./talksCardBackAlt.svg": 152,
	"./tcs.jpeg": 153,
	"./tiktok_logo.png": 154,
	"./udemy_logo.jpeg": 155,
	"./ui_ux_design.svg": 156,
	"./uwindsor_logo.jpeg": 157,
	"./uwindsor_logo_2.jpeg": 158,
	"./verzeo.jpeg": 159
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25;